const fadeInElements = document.querySelectorAll(".fade-in");

const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add("appear");
      observer.unobserve(entry.target); // optional: animate only once
    }
  });
});

fadeInElements.forEach((el) => observer.observe(el));
